// Typ dla logu
type LogLevel = "info" | "success" | "warning" | "error";

interface AppUpdateLog {
	id: string;
	timestamp: number;
	level: LogLevel;
	category: string;
	message: string;
	details?: Record<string, unknown>;
}

// Global log store - będzie zbierać logi z procesu aktualizacji aplikacji
export class AppUpdateLogger {
	private static logs: AppUpdateLog[] = [];
	private static listeners: Array<(logs: AppUpdateLog[]) => void> = [];
	private static maxLogs = 200;

	static log(
		level: LogLevel,
		category: string,
		message: string,
		details?: Record<string, unknown>
	) {
		const log: AppUpdateLog = {
			id: `${Date.now()}_${Math.random()}`,
			timestamp: Date.now(),
			level,
			category,
			message,
			details,
		};

		this.logs.unshift(log); // Najnowsze na górze
		if (this.logs.length > this.maxLogs) {
			this.logs = this.logs.slice(0, this.maxLogs);
		}

		this.notifyListeners();
	}

	static subscribe(listener: (logs: AppUpdateLog[]) => void) {
		this.listeners.push(listener);
		listener(this.logs); // Wyślij aktualne logi od razu
		return () => {
			this.listeners = this.listeners.filter((l) => l !== listener);
		};
	}

	private static notifyListeners() {
		this.listeners.forEach((listener) => listener([...this.logs]));
	}

	static clear() {
		this.logs = [];
		this.notifyListeners();
	}

	static getLogs() {
		return [...this.logs];
	}
}

// Skróty dla łatwiejszego użycia
export const appUpdateLog = {
	info: (category: string, message: string, details?: Record<string, unknown>) =>
		AppUpdateLogger.log("info", category, message, details),
	success: (
		category: string,
		message: string,
		details?: Record<string, unknown>
	) => AppUpdateLogger.log("success", category, message, details),
	warning: (
		category: string,
		message: string,
		details?: Record<string, unknown>
	) => AppUpdateLogger.log("warning", category, message, details),
	error: (category: string, message: string, details?: Record<string, unknown>) =>
		AppUpdateLogger.log("error", category, message, details),
};

